import { render, staticRenderFns } from "./IncomeForm.vue?vue&type=template&id=728ab6ae&"
import script from "./IncomeForm.vue?vue&type=script&lang=js&"
export * from "./IncomeForm.vue?vue&type=script&lang=js&"
import style0 from "./IncomeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports